



































import * as gqlSubcategories from "@/graphql/SubCategories.gql";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Route } from "vue-router";

type SortOptionId = "eventdate" | "onsaledate" | "popularity";

export type EventListFilter = {
  sort: SortOptionId;
  categoryIds: number[];
};

@Component({
  apollo: {
    subCategories: {
      query: gqlSubcategories,
      update(data) {
        return data.subCategories.sort(
          (a: { name: string }, b: { name: string }) =>
            a.name < b.name ? -1 : a.name > b.name ? 1 : 0
        );
      },
      variables() {
        return { categoryId: this.categoryId };
      }
    }
  }
})
export default class FilterBar extends Vue {
  @Prop() public readonly categoryId!: number;
  public settings: EventListFilter = null as any;
  public sortOptions: Array<{ id: SortOptionId; title: string }> = [
    { id: "eventdate", title: "Event Date" },
    { id: "onsaledate", title: "On-Sale Date" },
    { id: "popularity", title: "Popularity" }
  ];

  @Watch("$route", { immediate: true })
  public onRouteChanged({ query }: Route) {
    this.settings = {
      categoryIds: [].concat((query.categoryIds as any) || this.categoryId),
      sort: (query.sort as any) || "eventdate"
    };

    this.$emit("filterChange", this.settings);
  }

  public changed(key: keyof EventListFilter, value: any): void {
    this.$router.push({
      name: this.$route.name,
      query: { ...this.$route.query, [key]: value }
    });
  }
}
